/**
 * Admin content language switching mixin.
 * Main table = source language; other locales persist via /service/i18n/update.
 */
export default {
  data() {
    return {
      contentLang: 'en',
      sourceLang: 'en',
      contentLocales: ['en', 'zh', 'tw', 'ar', 'es', 'ru', 'nl', 'pl', 'it', 'fr', 'de', 'pt', 'ja', 'ko', 'hi', 'tr', 'id', 'ur', 'vi', 'th'],
      i18nFieldKeys: [],
      sourceSnapshot: null,
      i18nMetaLoaded: false
    }
  },
  methods: {
    async loadI18nMeta() {
      try {
        const res = await this.$api.post('/service/i18n/meta', {})
        if (this.$apiSuccess(res)) {
          this.sourceLang = res.data.source_locale || 'en'
          this.contentLocales = res.data.content_locales || ['en', 'zh', 'tw', 'ar', 'es', 'ru', 'nl', 'pl', 'it', 'fr', 'de', 'pt', 'ja', 'ko', 'hi', 'tr', 'id', 'ur', 'vi', 'th']
          if (!this.contentLang) {
            this.contentLang = this.sourceLang
          }
          this.i18nMetaLoaded = true
        }
      } catch (e) {
        this.sourceLang = 'en'
        this.contentLang = 'en'
      }
    },
    captureSourceSnapshot(detail, fields) {
      this.i18nFieldKeys = fields || this.i18nFieldKeys || []
      const snap = { ...(detail || {}) }
      this.sourceSnapshot = snap
      this.formData = { ...(detail || {}) }
    },
    async onContentLangChange(lang) {
      this.contentLang = lang
      await this.applyContentLangToForm()
    },
    async applyContentLangToForm() {
      if (!this.sourceSnapshot) return
      const fields = this.i18nFieldKeys || []
      // restore source fields first
      fields.forEach(k => {
        if (Object.prototype.hasOwnProperty.call(this.sourceSnapshot, k)) {
          this.$set(this.formData, k, this.sourceSnapshot[k])
        }
      })
      if (this.contentLang === this.sourceLang || !this.formData.id) {
        return
      }
      const res = await this.$api.post('/service/i18n/list', {
        entity_type: this.i18nEntityType,
        entity_id: this.formData.id
      })
      if (!this.$apiSuccess(res)) return
      const m = (res.data.by_locale || {})[this.contentLang] || {}
      fields.forEach(k => {
        if (m[k] != null && m[k] !== '') {
          this.$set(this.formData, k, m[k])
        }
      })
    },
    async saveLocalizedFields() {
      const fields = this.i18nFieldKeys || []
      for (let i = 0; i < fields.length; i++) {
        const field_key = fields[i]
        const field_value = this.formData[field_key] == null ? '' : String(this.formData[field_key])
        const res = await this.$api.post('/service/i18n/update', {
          entity_type: this.i18nEntityType,
          entity_id: this.formData.id,
          locale: this.contentLang,
          field_key,
          field_value
        })
        if (!this.$apiSuccess(res)) {
          throw new Error(res.message || `保存字段 ${field_key} 失败`)
        }
      }
    },
    isEditingSourceLang() {
      return !this.formData.id || this.contentLang === this.sourceLang
    }
  }
}
